import {ArchiveRecord, OTHER_PURPOSE} from 'archive/ArchiveConstants';

import {ArchiveRecordGraphQL} from '../../../graphql-fragments/app-core/platform/archivable/__generated/ArchiveRecordGraphQL';

export const ARCHIVE_RECORD: ArchiveRecord = {purpose: OTHER_PURPOSE};

export const ARCHIVE_RECORD_GQL: ArchiveRecordGraphQL = {
  __typename: 'ArchiveRecordNode',
  purpose: OTHER_PURPOSE,
};
